import { SelectHistoryTransactionOptions } from '@/redux/transactions/transactions.types'

export enum EStatementType {
  PERP = 'PERP',
  SPOT = 'SPOT',
}

export const options: SelectHistoryTransactionOptions<EStatementType>[] = [
  { label: EStatementType.PERP, value: EStatementType.PERP },
  { label: EStatementType.SPOT, value: EStatementType.SPOT },
]

export enum TigerXExchange {
  X_BINANCE = 'X Binance',
  X_OKX = 'X OKX',
}
